var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.2852V19.2852C1 17.4286 1.7375 15.6482 3.05025 14.3354C4.36301 13.0227 6.14348 12.2852 8 12.2852C9.85652 12.2852 11.637 13.0227 12.9497 14.3354C14.2625 15.6482 15 17.4286 15 19.2852V20.2852",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.2852C13 12.9591 13.5268 11.6873 14.4645 10.7496C15.4021 9.81194 16.6739 9.28516 18 9.28516C18.6566 9.28516 19.3068 9.41448 19.9134 9.66576C20.52 9.91703 21.0712 10.2853 21.5355 10.7496C21.9998 11.2139 22.3681 11.7651 22.6194 12.3717C22.8707 12.9784 23 13.6285 23 14.2852V14.7852",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.2852C9.06087 12.2852 10.0783 11.8637 10.8284 11.1136C11.5786 10.3634 12 9.34602 12 8.28516C12 7.22429 11.5786 6.20687 10.8284 5.45673C10.0783 4.70658 9.06087 4.28516 8 4.28516C6.93913 4.28516 5.92172 4.70658 5.17157 5.45673C4.42143 6.20687 4 7.22429 4 8.28516C4 9.34602 4.42143 10.3634 5.17157 11.1136C5.92172 11.8637 6.93913 12.2852 8 12.2852ZM18 9.28516C18.7956 9.28516 19.5587 8.96909 20.1213 8.40648C20.6839 7.84387 21 7.08081 21 6.28516C21 5.48951 20.6839 4.72645 20.1213 4.16384C19.5587 3.60123 18.7956 3.28516 18 3.28516C17.2044 3.28516 16.4413 3.60123 15.8787 4.16384C15.3161 4.72645 15 5.48951 15 6.28516C15 7.08081 15.3161 7.84387 15.8787 8.40648C16.4413 8.96909 17.2044 9.28516 18 9.28516Z",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientes);
export default __webpack_public_path__ + "static/media/clientes.6db4f7de579268fcb02c3d5063e4dd4d.svg";
export { ForwardRef as ReactComponent };